/*

    Column filter difrent types are handled differently in URL builder, 
    this function checks the type of filter and builds the URL accordingly. 
    It separates normal filters (string values), checkbox filters and date range filters.

*/
export default function checkFilterForURLBuilder(columnFilters) {
  const normal = [];
  const checkboxFilters = [];
  const date = [];

  for (const f of columnFilters) {
    if (!f.value) continue;

    if (f.value?.type === "dateRangeFilter") {
      const { from, to } = f.value;
      date.push(`${f.id}:${from || "-"},${to || "-"}`);
    } else if (f.value?.type === "checkboxFilter" && f.value.value) {
      const value = Array.isArray(f.value.value)
        ? f.value.value.join(",")
        : f.value.value;
      checkboxFilters.push(`${f.id}:${value}`);
    } else {
      const value = Array.isArray(f.value) ? f.value.join(",") : f.value;
      normal.push(`${f.id}:${value}`);
    }
  }

  return { normal, checkboxFilters, date };
}
